import type { ContactDisplayInfoProps } from "@survey-types/survey.contacts.types";

export const ContactDisplayInfo = ({ contact }: ContactDisplayInfoProps) => (
  <>
    {contact.name && (
      <div className="font-medium text-data w-full">{contact.name}</div>
    )}
    {contact.title && (
      <div className="text-data-light text-sm w-full">{contact.title}</div>
    )}
    {contact.licenseNo && (
      <div className="text-data-light text-sm w-full">{contact.licenseNo}</div>
    )}
    {contact.email && (
      <div className="text-data-light text-sm w-full">{contact.email}</div>
    )}
    {contact.phoneNumber && (
      <div className="text-data-light text-sm w-full">{contact.phoneNumber}</div>
    )}
  </>
);
